/**
 * Return Render
 *
 * This module provides functions around Order Detail.
 * - Virtual detail page generation (render/window history)
 * - Dependancy on our custom shopify theme
 */

import { MUAPP } from 'account/api';
import { state } from 'account/state';
import {
  orderDetailObjectReducer,
  displayOrderId,
  permissionErrorHandler,
} from 'account/utils';

// Static variables
const returnClassName = 'js-return-order';
const returnContainerClassName = `${returnClassName}-container`;
const returnIdClassName = `${returnClassName}-id`;
const returnImageClassName = `${returnClassName}--image-container`;
const sampleSizes = ['18" x 18" sample', '1\'-6" x 1\'-6" square'];

/**
 * returnFileUploadHandler
 * @function
 *
 * @param {string} id - SPARS(Shopify) order ID
 *
 * Injects SPARS order ID in DOM
 * NOTE: Refactor possible, could move to utils?
 */
const returnFileUploadHandler = (customerId = null) => {
  $('.js-file-input').change(function () {
    const inputTarget = $(this).data('targetid');
    const $fileName = $(this)
      .closest(`.${returnImageClassName}`)
      .find('.custom-file-upload__name');

    const $buttonText = $(this)
      .closest(`.${returnImageClassName}`)
      .find('.custom-file-upload__button');
    const fileName = $(this)[0].files[0].name;
    customerId = customerId ? customerId : '12345'; // Temp

    $fileName.text('Uploading...');

    var form = new FormData();
    form.append('photo', $(this)[0].files[0]);
    form.append('customerid', customerId);

    MUAPP.returns.uploadReturnImage(
      form,
      (data) => {
        $fileName.text(fileName).addClass('custom-file-upload__name--file');
        $(`#${inputTarget}`).val($.parseJSON(data).image);
        $buttonText.text('Replace File');
      },
      (data) => {
        $fileName.text('Error occured.');
      },
    );
  });
};

function isReturnRequested(detail = {}) {
  return detail.ReturnQty < 1 ? false : true;
}

function isReturnable(detail = {}) {
  return detail.ShopifyItem.product_type != 'RUGS' ||
    detail.ShopifyItem.variant.title == 'Not Found' ||
    sampleSizes.includes(detail.ShopifyItem.variant.title.toLowerCase())
    ? false
    : true;
}

function getMaxReturnable(detail = {}) {
  return detail.ReturnQty
    ? detail.OrderQty - detail.ReturnQty
    : detail.OrderQty;
}

/**
 * returnDetail
 * @function
 *
 * @param {string} id - SPARS(Shopify) order ID
 * @param {array} orders - An array of SPARS orders object
 *
 * if url query string has 'order-history' view attribute & id
 */
const returnDetail = (order = [], customerId = null) => {
  if (!$(`.${returnClassName}`).length) return;
  // let order = orders.filter(order => order.Header.OrderNo == id)[0];
  let output = '';

  // To add additional attirbutes in order object
  order = orderDetailObjectReducer(order);

  if (order.Shipments.length > 0) {
    order.Shipments.forEach((shipment) => {
      shipment.Detail.forEach((detail) => {
        if (detail.ReturnQty > 0) {
          detail.ReturnRequested = isReturnRequested(detail);
          detail.Returnable = false;
        } else {
          detail.Returnable = isReturnable(detail);
        }
        output += window.returnProductTemplate
          ? window.returnProductTemplate.render(detail)
          : JSON.parse(detail);
      });
    });
  }

  if (order.PreparingToShip.length > 0) {
    order.PreparingToShip.forEach((detail) => {
      detail.Returnable = false;
      output += window.returnProductTemplate
        ? window.returnProductTemplate.render(detail)
        : JSON.parse(detail);
    });
  }

  if (order.Pendings.length > 0) {
    order.Pendings.forEach((detail) => {
      detail.Returnable = false;
      output += window.returnProductTemplate
        ? window.returnProductTemplate.render(detail)
        : JSON.parse(detail);
    });
  }
  if (order.Returns.length > 0) {
    order.Returns.forEach((detail) => {
      detail.Returnable = false;
      detail.ReturnRequested = isReturnRequested(detail);
      output += window.returnProductTemplate
        ? window.returnProductTemplate.render(detail)
        : JSON.parse(detail);
    });
  }
  if (order.isCancels.length > 0) {
    order.isCancels.forEach((detail) => {
      detail.Returnable = false;
      output += window.returnProductTemplate
        ? window.returnProductTemplate.render(detail)
        : JSON.parse(detail);
    });
  }

  $(`.${returnContainerClassName}`).html('').append(output);
  window.pubsub.trigger('returnDetailRendered'); // NOTE: Is being listened in Theme
  window.pubsub.on(
    'returnDetailRenderFinished',
    returnFileUploadHandler(customerId),
  );
};

const returnRenderHandler = (id = null) => {
  displayOrderId(id, returnIdClassName);
  MUAPP.orders.getOrderById(id).then((data) => {
    if (data.Error)
      return permissionErrorHandler(returnContainerClassName, 'mt-8');
    state.order = data.order; // Cache
    returnDetail(data.order, customerId);
  });
};

export { returnRenderHandler, returnFileUploadHandler };



// WEBPACK FOOTER //
// ./src/scripts/src/account/returns.js